<template>
  <base-dropdown class="w-full" v-model="isActive" v-bind="$attrs" min-width="227" placement="bottom-end">
    <template v-slot:button="{ toggle, identifier }">
      <base-input-group>
        <base-input v-model="localValue" @click="toggle" readonly="readonly" data-lpignore="true" allow-1password="no"/>

        <base-input-group-text :id="identifier" slot="append" class="color-preview" :style="{ backgroundColor: localValue }" @click="toggle"/>
      </base-input-group>
    </template>

    <chrome-picker class="color-picker" :value="localValue" @input="updateFromPicker" />
  </base-dropdown>
</template>

<script>
import ChromePicker from 'vue-color/src/components/Chrome.vue'

export default {
  name: 'BaseColorPicker',

  props: {
    value: {
      type: String,
      default: '#000000'
    }
  },

  components: { ChromePicker },

  data () {
    return {
      isActive: false
    }
  },

  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    updateFromPicker (color) {
      this.localValue = color.rgba.a === 1 ? color.hex : 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
    }
  }
}
</script>
